// Mock data for ForrosPro website

export const mockData = {
  company: {
    name: "Rei do Teto",
    tagline: "Excelência em Forros e Acabamentos",
    phone: "(27) 99636-9622",
    email: "contato@reidoteto.com.br",
    address: "Grande Vitória - ES",
    whatsapp: "5527996369622",
    social: {
      instagram: "https://www.instagram.com/reidoteto027/"
    }
  },

  services: [
    {
      id: 1,
      title: "Forro de Gesso",
      slug: "forro-gesso",
      description: "Acabamento perfeito e elegante para ambientes sofisticados",
      fullDescription: "O forro de gesso é uma solução clássica e versátil que oferece acabamento impecável para residências e estabelecimentos comerciais. Permite a criação de designs personalizados com iluminação embutida, sancas e detalhes arquitetônicos únicos.",
      benefits: [
        "Acabamento liso e uniforme",
        "Possibilidade de iluminação embutida",
        "Isolamento térmico e acústico",
        "Durabilidade e resistência",
        "Design personalizado"
      ],
      applications: ["Residencial", "Comercial", "Corporativo"],
      image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80"
    },
    {
      id: 2,
      title: "Forro de PVC",
      slug: "forro-pvc",
      description: "Resistente à umidade, ideal para áreas molhadas",
      fullDescription: "O forro de PVC é a escolha ideal para ambientes com alta umidade como banheiros, cozinhas e áreas externas cobertas. Oferece fácil manutenção, limpeza simples e grande variedade de cores e texturas.",
      benefits: [
        "Resistente à umidade e mofo",
        "Fácil limpeza e manutenção",
        "Instalação rápida",
        "Ótimo custo-benefício",
        "Diversas cores e acabamentos"
      ],
      applications: ["Banheiros", "Cozinhas", "Áreas externas", "Garagens"],
      image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80"
    },
    {
      id: 3,
      title: "Forro Acartonado",
      slug: "forro-acartonado",
      description: "Moderno, versátil e perfeito para projetos contemporâneos",
      fullDescription: "O forro em drywall (acartonado) oferece versatilidade incomparável para projetos modernos. Permite criar diferentes níveis, curvas e formas, além de facilitar a passagem de instalações elétricas e hidráulicas.",
      benefits: [
        "Design moderno e clean",
        "Versatilidade em formatos",
        "Fácil acesso a instalações",
        "Acabamento profissional",
        "Isolamento termo-acústico"
      ],
      applications: ["Escritórios", "Lojas", "Residências modernas"],
      image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80"
    },
    {
      id: 4,
      title: "Forros Personalizados",
      slug: "forros-personalizados",
      description: "Sancas, nichos e projetos sob medida",
      fullDescription: "Criamos projetos exclusivos com sancas iluminadas, nichos decorativos e detalhes arquitetônicos que transformam o ambiente. Cada projeto é desenvolvido de acordo com o estilo e necessidades do cliente.",
      benefits: [
        "Projeto exclusivo",
        "Iluminação diferenciada",
        "Valorização do imóvel",
        "Detalhes únicos",
        "Consultoria personalizada"
      ],
      applications: ["Salas de estar", "Quartos", "Halls de entrada"],
      image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80"
    }
  ],

  differentials: [
    {
      id: 1,
      title: "Atendimento Rápido",
      description: "Resposta em até 24 horas e visitas agendadas conforme sua disponibilidade"
    },
    {
      id: 2,
      title: "Instalação Profissional",
      description: "Equipe qualificada e experiente com acabamento impecável"
    },
    {
      id: 3,
      title: "Garantia de Serviço",
      description: "Garantia de 12 meses em todos os serviços realizados"
    },
    {
      id: 4,
      title: "Qualidade Comprovada",
      description: "Mais de 500 projetos executados com excelência"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Maria Silva",
      role: "Proprietária Residencial",
      content: "Excelente trabalho! O forro de gesso ficou perfeito na minha sala. A equipe foi pontual, limpa e muito profissional. Recomendo!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80"
    },
    {
      id: 2,
      name: "João Pereira",
      role: "Gerente Comercial",
      content: "Contratamos para nossa loja e o resultado superou as expectativas. O forro acartonado com iluminação embutida valorizou muito o ambiente.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
    },
    {
      id: 3,
      name: "Ana Costa",
      role: "Arquiteta",
      content: "Já indiquei para vários clientes. Trabalho de qualidade, cumprem prazos e o acabamento é impecável. Parceria de confiança!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80"
    }
  ],

  gallery: [
    {
      id: 1,
      category: "gesso",
      title: "Sala de Estar com Sancas",
      image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80"
    },
    {
      id: 2,
      category: "pvc",
      title: "Cozinha Moderna",
      image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&q=80"
    },
    {
      id: 3,
      category: "gesso",
      title: "Quarto com Iluminação",
      image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600&q=80"
    },
    {
      id: 4,
      category: "acartonado",
      title: "Escritório Corporativo",
      image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80"
    },
    {
      id: 5,
      category: "personalizado",
      title: "Hall de Entrada",
      image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&q=80"
    },
    {
      id: 6,
      category: "gesso",
      title: "Sala Comercial",
      image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600&q=80"
    }
  ],

  blogPosts: [
    {
      id: 1,
      title: "Tipos de Forros: Qual Escolher para Seu Projeto?",
      excerpt: "Conheça as principais opções de forros disponíveis no mercado e suas características para fazer a melhor escolha.",
      date: "2024-03-15",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80",
      category: "Guias"
    },
    {
      id: 2,
      title: "Manutenção de Forros: Cuidados Essenciais",
      excerpt: "Dicas práticas para manter seu forro sempre bonito e prolongar sua durabilidade.",
      date: "2024-03-10",
      image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80",
      category: "Manutenção"
    },
    {
      id: 3,
      title: "Tendências em Forros para 2024",
      excerpt: "Descubra as principais tendências de design e materiais para forros neste ano.",
      date: "2024-03-05",
      image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=600&q=80",
      category: "Tendências"
    }
  ]
};
